import styled from "styled-components";

export const Image = styled.img<{ maxContent?: boolean; contain?: boolean; position?: string }>`
    width: ${({ maxContent = false }) => (maxContent ? "max-content" : "100%")};
    height: auto;
    object-fit: ${({ contain = false }) => (contain ? "contain" : "none")};
    object-position: ${({ position = "unset" }) => position};
`;

export const Thumbnail = styled.img`
    object-fit: contain;
    width: 100%;
    height: 100%;
    object-position: center;
`;
